<div class="editor-header">
  <span class="editor-header-text">
    {{effectNode.label}}
  </span>
  <span class="toolbar-spacer"></span>
  <span>
    <button mat-icon-button matTooltip="Move Up" *ngIf="!isFirst" [ngClass]="{'move-up': isLast}" (click)="moveUp()">
      <mat-icon aria-label="Move Up">arrow_upward</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Move Down" *ngIf="!isLast" (click)="moveDown()">
      <mat-icon aria-label="Move Down">arrow_downward</mat-icon>
    </button>
    <avr-doubleclick-delete-button (delete)="delete()"></avr-doubleclick-delete-button>
  </span>
</div>

<ng-template effectHost></ng-template>

<div *ngIf="debugMode">
  <mat-divider></mat-divider>
  <span class="auto-label">Debug Information</span>
  <pre class="text-monospace" [innerHTML]="effectYAML"></pre>
</div>

